import { Card, Tab, Nav } from 'react-bootstrap';
import { NavTab, TabPane } from './TabNavigations';
import { ContainerSFDetail } from '../SubconFinishing';

export const TabSubcon = () => {
  return (
    <Card className="mt-4">
      <Tab.Container defaultActiveKey="sf">
        <Card.Header>
          <Nav variant="tabs" defaultActiveKey="sf">
            <NavTab eventKey="sf" title="Subcon Finishing" />
          </Nav>
        </Card.Header>

        <Card.Body>
          <Tab.Content>
            <TabPane eventKey="sf" component={<ContainerSFDetail />} />
          </Tab.Content>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};
